import React, { useState } from 'react';
import { Card } from '../../components/ui/Kit';
import { useAuth } from '../../contexts/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import KeepAliveTab from './KeepAliveTab';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiUsers, FiDatabase, FiActivity } = FiIcons;

const TABS = [
  { id: 'overview', label: 'Overview', icon: FiShield },
  { id: 'keepalive', label: 'Keep-Alive Monitor', icon: FiActivity },
];

export default function Admin() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  const panels = [
    { icon: FiUsers, label: 'All Agencies', value: '—', color: 'text-blue-500', bg: 'bg-blue-50' },
    { icon: FiDatabase, label: 'Total Leads', value: '—', color: 'text-green-500', bg: 'bg-green-50' },
    { icon: FiActivity, label: 'Active Sessions', value: '—', color: 'text-purple-500', bg: 'bg-purple-50' },
    { icon: FiShield, label: 'Super Admins', value: '1', color: 'text-red-500', bg: 'bg-red-50' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-red-100 rounded-lg">
          <SafeIcon icon={FiShield} className="h-6 w-6 text-red-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Super Admin Panel</h1>
          <p className="text-sm text-gray-500">
            Logged in as <span className="font-semibold text-red-600">{user?.full_name}</span> · super_admin
          </p>
        </div>
      </div>

      <div className="border-b border-gray-200 bg-white rounded-t-lg overflow-x-auto">
        <nav className="flex gap-0 min-w-max">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <SafeIcon icon={tab.icon} className="w-4 h-4" />
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'overview' && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {panels.map((p, i) => (
              <Card key={i} className="p-6 flex items-center gap-4">
                <div className={`p-3 rounded-lg ${p.bg}`}>
                  <SafeIcon icon={p.icon} className={`h-6 w-6 ${p.color}`} />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">{p.label}</p>
                  <p className="text-2xl font-bold text-gray-900">{p.value}</p>
                </div>
              </Card>
            ))}
          </div>

          <Card className="p-8 text-center border-dashed border-2 border-gray-200 bg-gray-50">
            <SafeIcon icon={FiShield} className="h-10 w-10 text-gray-300 mx-auto mb-3" />
            <p className="text-gray-500 text-sm">
              Full super admin controls coming soon. Only <strong>super_admin</strong> role can access this page.
            </p>
          </Card>
        </>
      )}

      {activeTab === 'keepalive' && <KeepAliveTab />}
    </div>
  );
}
